import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Navigate } from 'react-router-dom';
import { useCognitoAuthContext } from '@caplend/cognito-auth';
import LoginWizard from '../../components/LoginWizard';
import hansepayWhiteLogo from '../../assets/hansepay-white.png';

function Login() {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasAccessToken } = useCognitoAuthContext();
  const initialEmail = location.state?.email ?? '';
  const [oauthError] = useState(() => location.state?.oauthError);
  const from = location.state?.from;
  const fromPath = typeof from?.pathname === 'string' ? `${from.pathname}${from.search ?? ''}${from.hash ?? ''}` : null;

  useEffect(() => {
    if (location.state?.oauthError) {
      navigate('/login', { replace: true, state: {} });
    }
  }, [location.state?.oauthError, navigate]);

  if (hasAccessToken) {
    return <Navigate to={fromPath || '/dashboard'} replace />;
  }

  return (
    <div className='min-h-screen bg-[#EBF4FB] text-[#0B1929]'>
      <header className='flex h-[60px] items-center bg-[linear-gradient(135deg,#060D1A_0%,#0F2540_55%,#163659_100%)] px-5 sm:px-10'>
        <a href='/' className='flex items-center gap-2.5 no-underline'>
          <img src={hansepayWhiteLogo} width={26} height={26} alt='HansePay' className='block shrink-0' />
          <span className='wordmark inline-block translate-y-px text-[18px] leading-none tracking-[-0.015em] text-white'>HansePay</span>
        </a>
      </header>

      <main className='flex justify-center px-4 pb-16 pt-[10vh] sm:px-6'>
        <div className='w-full max-w-[540px]'>
          <LoginWizard initialEmail={initialEmail} initialError={oauthError} />
        </div>
      </main>
    </div>
  );
}

export default Login;
